'use es6';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { css } from 'foundations-theming/utils';
import { SECTION, ELEMENT, LAYOUT, SAVE_SECTION } from 'LayoutBuilderUI/lib/DragDropConstants';
import { DropTarget } from 'react-dnd-compat';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsFileManagerOpen } from 'LayoutBuilderUI/selectors/userInterface';
import { dropNewImageElement } from 'LayoutBuilderUI/actions/layoutActions';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import { DropPosition } from 'EmailEditorUI/redux/actions/types/layoutActions';
import { NativeTypes } from 'react-dnd-ipeui-backend';
import { compose } from 'redux';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyPlaceholderMessage = styled.div.withConfig({
  displayName: "EmptyTemplatePlaceholder__EmptyPlaceholderMessage"
})(({
  isHovered,
  theme
}) => {
  return css(["min-height:60px;border-radius:", ";border-style:dashed;border-width:", ";border-color:", ";background-color:", ";display:flex;justify-content:center;align-items:center;flex-basis:100%;", ""], theme.borderRadius[200], theme.borderWidth[100], theme.color['icon-tertiary-default'], theme.color['fill-tertiary-hover'], isHovered && css(["border-color:", ";background-color:", ";"], theme.color['border-interactive-default'], theme.color['fill-info-subtle']));
});
const widgetDragTarget = {
  drop(props, monitor) {
    const itemType = monitor.getItemType();
    const dropProps = {
      dropPosition: DropPosition.BEFORE,
      newSection: true,
      sectionIndex: 0,
      type: itemType === SAVE_SECTION ? SAVE_SECTION : SECTION
    };
    const isFile = itemType === NativeTypes.FILE;
    if (isFile) {
      const item = monitor.getItem();
      const file = item.files && item.files.length ? item.files[0] : null;
      if (file) {
        props.dropNewImageElement(Object.assign({
          file
        }, dropProps));
      }
      return undefined;
    }
    return dropProps;
  },
  canDrop: props => !props.isFileManagerOpen
};
function EmptyTemplatePlaceholder({
  connectDropTarget,
  isOver,
  canDrop,
  isEmpty
}) {
  const placeholderContent = connectDropTarget( /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(EmptyPlaceholderMessage, {
      isHovered: canDrop && isOver,
      children: isEmpty ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "layoutBuilder.placeholders.emptyTemplate"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "layoutBuilder.placeholders.hiddenTemplate"
      })
    })
  }));
  return /*#__PURE__*/_jsx(NamespaceWrapper, {
    children: /*#__PURE__*/_jsx("div", {
      className: "hse-column-container empty-template-placeholder",
      children: /*#__PURE__*/_jsx("div", {
        className: "hs_cos_wrapper_widget hs_cos_wrapper_widget_placeholder",
        children: placeholderContent
      })
    })
  });
}
EmptyTemplatePlaceholder.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool.isRequired,
  isEmpty: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  isFileManagerOpen: getIsFileManagerOpen(state)
});
const mapDispatchToProps = {
  dropNewImageElement
};
export default compose(connect(mapStateToProps, mapDispatchToProps), DropTarget([ELEMENT, LAYOUT, NativeTypes.FILE, SAVE_SECTION], widgetDragTarget, monitor => ({
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
})))(EmptyTemplatePlaceholder);